
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  computed: {
    plural () {
      return this.post.readingTime && this.post.readingTime > 0
        ? `s`
        : ``;
    },
  },
};
